export enum LeadInactivityTypeEnum {
  REROUTE_TO_OFFICE = "reroute to office",
}
